// DS: C58A, C58A_M
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import HeaderMobile from './HeaderMobile';
import HeaderDesktop from './HeaderDesktop';
import { TabBarProps } from './types';
import SearchBar from './_partials/SearchBar';

import s from './Header.scss';

const Header: React.FC<TabBarProps> = ({
  isSearchPage,
  pageType,
  items,
  activeMenuItem,
}) => {
  const isMobile = useContext(MobileContext);

  return (
    <>
      {isSearchPage && <SearchBar isMobile={isMobile} pageType={pageType} />}
      <div className={s['header-container']}>
        {isMobile ? (
          <HeaderMobile
            pageType={pageType}
            isSearchPage={isSearchPage}
            items={items}
            activeMenuItem={activeMenuItem}
          />
        ) : (
          <HeaderDesktop
            pageType={pageType}
            isSearchPage={isSearchPage}
            items={items}
            activeMenuItem={activeMenuItem}
          />
        )}
      </div>
    </>
  );
};
Header.displayName = 'Header';

export default Header;
